
import { Link } from 'react-router-dom';

const ServiceSectors = () => {
  const sectors = [
    {
      icon: 'ri-home-4-line',
      title: 'Residential',
      subtitle: 'Homes & Properties',
      description: 'Professional electrical services for homeowners and property investors. Safe, compliant, and reliable solutions for your home.',
      services: ['Switchboard Upgrades', 'Lighting Installations', 'Power Points', 'RCD Safety', 'Renovations'],
      link: '/residential-services',
      image: 'https://public.readdy.ai/ai/img_res/a26a523b29427d6fa396f6b71afaca72.jpg',
    },
    {
      icon: 'ri-building-2-line',
      title: 'Commercial',
      subtitle: 'Business & Retail',
      description: 'Specialised electrical installations for commercial properties, offices, and retail spaces. Designed for efficiency and compliance.',
      services: ['Commercial Fit-Outs', 'Compliance Testing', 'Maintenance Contracts', 'Lighting Systems', 'Power Distribution'],
      link: '/commercial-services',
      image: 'https://readdy.ai/api/search-image?query=modern%20commercial%20office%20building%20interior%20with%20professional%20LED%20lighting%20installation%20and%20sleek%20electrical%20systems%20showing%20contemporary%20business%20space%20with%20glass%20partitions%20and%20organized%20cable%20management%20in%20bright%20corporate%20environment&width=600&height=400&seq=commercial-sector-v3&orientation=landscape',
    },
    {
      icon: 'ri-building-4-line',
      title: 'Industrial',
      subtitle: 'Factories & Warehouses',
      description: 'Industrial-grade electrical services for manufacturing facilities, warehouses, and heavy industry. Built for reliability and safety.',
      services: ['Three-Phase Systems', 'Motor Connections', 'Control Panels', 'Preventative Maintenance', 'Fault Diagnostics'],
      link: '/industrial-services',
      image: 'https://readdy.ai/api/search-image?query=industrial%20warehouse%20interior%20with%20heavy%20duty%20electrical%20installations%20and%20three%20phase%20power%20systems%20showing%20professional%20industrial%20electrical%20work%20with%20large%20switchboards%20and%20organized%20conduit%20runs%20in%20modern%20manufacturing%20facility&width=600&height=400&seq=industrial-sector-v3&orientation=landscape',
    },
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <p className="text-gold font-bold text-sm tracking-widest uppercase mb-3">OUR EXPERTISE</p>
          <h2 className="text-4xl lg:text-5xl font-bold text-navy mb-6">Three Sectors. One Standard.</h2>
          <p className="text-charcoal text-lg max-w-3xl mx-auto leading-relaxed">
            Whether it is your home, your business, or your industrial facility, NS Electrical WA delivers the same commitment to quality, safety, and compliance.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {sectors.map((sector, index) => (
            <div
              key={index}
              className="group bg-white rounded-lg overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500 border border-gray-100"
            >
              <div className="relative h-56 overflow-hidden">
                <img
                  src={sector.image}
                  alt={sector.title}
                  className="w-full h-full object-cover object-center group-hover:scale-110 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-navy/80 to-transparent"></div>
                <div className="absolute bottom-4 left-4 right-4">
                  <div className="flex items-center gap-3">
                    <div className="w-12 h-12 rounded-lg bg-gold flex items-center justify-center">
                      <i className={`${sector.icon} text-navy text-2xl`}></i>
                    </div>
                    <div>
                      <h3 className="text-white font-bold text-xl">{sector.title}</h3>
                      <p className="text-gold text-sm font-medium">{sector.subtitle}</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="p-6">
                <p className="text-charcoal text-sm leading-relaxed mb-6">{sector.description}</p>
                
                <div className="space-y-2 mb-6">
                  {sector.services.map((service, idx) => (
                    <div key={idx} className="flex items-center gap-2">
                      <i className="ri-check-line text-gold text-lg w-4 h-4 flex items-center justify-center"></i>
                      <span className="text-charcoal text-sm">{service}</span>
                    </div>
                  ))}
                </div>

                <Link
                  to={sector.link}
                  className="inline-flex items-center justify-center gap-2 w-full bg-navy text-white py-3 rounded-lg font-bold text-sm tracking-wider hover:bg-gold hover:text-navy transition-all whitespace-nowrap cursor-pointer"
                >
                  VIEW SERVICES
                  <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServiceSectors;
